import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07879b56"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-renderer-id"]
const _hoisted_2 = { class: "ss-mode-toggle" }
const _hoisted_3 = {
  key: 0,
  class: "ss-missing-context",
  "data-id": "ss-tree-readonly"
}
const _hoisted_4 = {
  key: 2,
  class: "ss-missing-context"
}
const _hoisted_5 = {
  class: "ss-recovery",
  "data-id": "ss-recovery"
}
const _hoisted_6 = {
  key: 0,
  class: "ss-recovery-msg",
  "data-id": "ss-recovery-msg"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectionSetTree = _resolveComponent("SelectionSetTree")!
  const _component_control_wrapper = _resolveComponent("control-wrapper")!
  const _component_StringControlRenderer = _resolveComponent("StringControlRenderer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ss-control",
    "data-renderer-id": _ctx.RendererConfigurations.SelectionSetControlRenderer.name
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(['ss-mode-btn', { active: _ctx.mode === 'tree' }]),
        "data-id": "ss-mode-tree",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchMode('tree')))
      }, " Tree ", 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(['ss-mode-btn', { active: _ctx.mode === 'raw' }]),
        "data-id": "ss-mode-raw",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchMode('raw')))
      }, " Raw ", 2)
    ]),
    (_ctx.mode === 'tree')
      ? (_openBlock(), _createBlock(_component_control_wrapper, _mergeProps({ key: 0 }, _ctx.controlWrapper, {
          styles: _ctx.styles,
          isFocused: _ctx.isFocused,
          appliedOptions: _ctx.appliedOptions
        }), {
          default: _withCtx(() => [
            (_ctx.hasContext && _ctx.treeReadOnly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " This selection contains injected values (outputs, variables or functions) that the tree can’t edit without dropping them. Switch to Raw to change it. "))
              : _createCommentVNode("", true),
            (_ctx.hasContext)
              ? (_openBlock(), _createBlock(_component_SelectionSetTree, {
                  key: 1,
                  "connector-id": _ctx.options.connectorId,
                  revision: _ctx.options.revision,
                  "root-type": _ctx.options.rootType,
                  operation: _ctx.options.operation,
                  field: _ctx.options.field,
                  "model-value": _ctx.modelString,
                  disabled: !_ctx.control.enabled || _ctx.treeReadOnly,
                  "onUpdate:modelValue": _ctx.onUpdate,
                  onFallback: _ctx.onFallback
                }, null, 8, ["connector-id", "revision", "root-type", "operation", "field", "model-value", "disabled", "onUpdate:modelValue", "onFallback"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, " Selection tree unavailable for this action; use Raw. "))
          ]),
          _: 1
        }, 16, ["styles", "isFocused", "appliedOptions"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.parseError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " This selection can’t be shown as a tree (invalid GraphQL). Fix it below, or restore a valid selection: "))
              : _createCommentVNode("", true),
            (_ctx.canReset)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "ss-recovery-btn",
                  "data-id": "ss-recovery-default",
                  disabled: !_ctx.control.enabled,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetToDefault && _ctx.resetToDefault(...args)))
                }, " Reset to default ", 8, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "ss-recovery-btn",
              "data-id": "ss-recovery-revert",
              disabled: !_ctx.control.enabled || !_ctx.hasInitial,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revertToSaved && _ctx.revertToSaved(...args)))
            }, " Revert to last saved ", 8, _hoisted_8)
          ]),
          _createVNode(_component_StringControlRenderer, _normalizeProps(_guardReactiveProps({ ..._ctx.$props, ..._ctx.$attrs })), null, 16)
        ], 64))
  ], 8, _hoisted_1))
}